import overview from './overview.json';
import saasAvailabilityChart from './widgets/saasAvailabilityChart.json';
import saasJitterChart from './widgets/saasJitterChart.json';
import saasMinLatencyChart from './widgets/saasMinLatencyChart.json';
import saasMaxLatencyChart from './widgets/saasMaxLatencyChart.json';
import saasTimeChart from './widgets/saasTimeChart.json';
import saasLossChart from './widgets/saasLossChart.json';
import saasStatusCards from './widgets/saasStatusCards.json';
import saasAvailabilityDataTable from './widgets/saasAvailabilityDataTable.json';

export default [
  overview,
  saasJitterChart,
  saasMinLatencyChart,
  saasMaxLatencyChart,
  saasTimeChart,
  saasLossChart,
  saasAvailabilityChart,
  saasStatusCards,
  saasAvailabilityDataTable,
];
